import React from 'react';
import Popup from 'reactjs-popup';
import { useV3OfferContext } from '../contexts/V3OfferContext';
import useV3OfferTemplate, { ORIGIN } from '../hooks/useV3OfferTemplate';
import '../styles/ftux.css';

const cls = (...names) => names.filter(Boolean).join(' ');

const V3OfferOriginCard = () => {
  // Tolerates a missing V3OfferProvider (bare test renders) — same contract as
  // useV3OfferTemplate, which returns inert handlers when context is absent.
  const offer = useV3OfferContext()?.offer;
  const { origin, openFtuxModal, handlers, modals } = useV3OfferTemplate();

  const templateLinked = !!offer?.template_id;
  const isSavedTemplate = origin === ORIGIN.SAVED_TEMPLATE;

  const triggerBtn = (
    <button
      type="button"
      className={cls('deal-terms-form__template-chevron-btn')}
      aria-label="Template options"
      aria-haspopup="menu"
      data-testid="v3-origin-overflow"
    >
      <i className="fas fa-chevron-down" aria-hidden="true" />
    </button>
  );

  return (
    <span data-testid="v3-offer-origin-card">
      <Popup
        trigger={triggerBtn}
        position="bottom right"
        arrow={false}
        className="v3-origin-overflow-popup"
        closeOnDocumentClick
      >
        {(close) => (
          <div role="menu">
            <button
              type="button"
              role="menuitem"
              className="v3-origin-overflow-item"
              onClick={() => { close(); handlers.handleSaveAsNewOpen(); }}
              data-testid="v3-origin-save-as-new"
            >
              Save as new template
            </button>
            {isSavedTemplate && (
              <button
                type="button"
                role="menuitem"
                className="v3-origin-overflow-item"
                onClick={() => { close(); handlers.handleUpdate(); }}
                data-testid="v3-origin-update"
              >
                Save to current template
              </button>
            )}
            {templateLinked && (
              <button
                type="button"
                role="menuitem"
                className="v3-origin-overflow-item"
                onClick={() => { close(); handlers.handleViewDetails(); }}
              >
                View template details
              </button>
            )}
            <button
              type="button"
              role="menuitem"
              className="v3-origin-overflow-item"
              onClick={() => { close(); if (openFtuxModal) openFtuxModal(offer); }}
              data-testid="v3-origin-change-template"
            >
              Change template…
            </button>
            {templateLinked && (
              <>
                <div className="v3-origin-overflow-divider" role="separator" />
                <button
                  type="button"
                  role="menuitem"
                  className="v3-origin-overflow-item v3-origin-overflow-item--destructive"
                  onClick={() => { close(); handlers.handleUnlink(); }}
                  data-testid="v3-origin-unlink"
                >
                  Unlink from template
                </button>
              </>
            )}
          </div>
        )}
      </Popup>
      {modals}
    </span>
  );
};

export default V3OfferOriginCard;
